import { useEffect, useState, useRef } from "react";
import { Tab, Tabs } from "react-bootstrap"
import { AgGridReact } from "ag-grid-react";
import { useDispatch, useSelector } from "react-redux";
import { sbaAxios } from "../../../../utils/sbaAxios";
import { CalculationTab } from "./CalculationTab";
import { getBillableAssetToFlagAPI, getBillableAssetsGetExistingAPI, insertNewBillableAsset,updateBillableAsset,
  deleteBillableAsset } from "../../../../../config/apiConfig";
import { SBADrawer } from "../../../../UiComponents/SBADrawer";
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';

export const Billing = () => {

  const [activeTab, setActiveTab] = useState("BillableAsset");
  return <>
    <Tabs activeKey={activeTab} onSelect={(key) => { setActiveTab(key) }}>
      <Tab className="life-science rounded  border-top-0 " eventKey="BillableAsset" title="Billable Asset" >
        {activeTab === "BillableAsset" && <><BillableAsset /></>}
      </Tab>
      <Tab className="life-science rounded  border-top-0" eventKey="Calculation" title="Calculation">
        {activeTab === "Calculation" && <><CalculationTab /></>}
      </Tab>
    </Tabs>
  </>
};
const BillableAsset = () => {
  const [billableAsset, setBillableAsset] = useState([]);
  const [createNewbillableAsset, setCreateNewbillableAsset] = useState([]);
  const Gstate = useSelector(state => state);
  const [selectedTab, setSelectedTab] = useState(1);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async()=>{
      await getExistingBillableAsset().then(res => {
        setBillableAsset(res);
      }
      ).catch(res => {
        setBillableAsset([]);
      }
      );
      await getBillableAssettoFlag().then(res => {
        setCreateNewbillableAsset(res);
      }
      ).catch(res => {
        setCreateNewbillableAsset([]);
      }
      );
    }
    fetchData();
  }, []);

  const handleBillableAssetChange = (billableAssets, newBillableAssets) =>{
    setBillableAsset(billableAssets);
    setCreateNewbillableAsset(newBillableAssets)
  }

  const handleBillableAssets = (billableAssets) =>{
    setBillableAsset(billableAssets)
  }

  const getExistingBillableAsset = async () => {
    try {
      const list = await sbaAxios({url:getBillableAssetsGetExistingAPI});
      return list;
    } catch (error) {
      return [];
    }
  };
  const getBillableAssettoFlag=async()=>{
    try {
      const list = await sbaAxios({url:getBillableAssetToFlagAPI});
      return list;
    } catch (error) {
      return [];
    }
  }

 
  return  <div className="p-2 d-flex">
  <div className="button-container verticalTabButton" >
        <button
          className={`non-gappable-button ${selectedTab === 1 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={() => { setSelectedTab(1) }}
        >
          Existing
        </button>

        <button
          className={`non-gappable-button ${selectedTab === 2 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={() => { setSelectedTab(2) }}
        >
          Create New
        </button>
      </div>
    <div className="p-2 flex-grow-1">
    { 
    selectedTab ==1 && <>
    <ExistingBillableAsset 
        billableAsset={billableAsset}  
        handleBillableAssetChange={handleBillableAssetChange} 
        setBillableAssets={handleBillableAssets}
    />
      </>
    }
    {
      selectedTab==2 && <>
      <CreateNewBillableAsset 
        createNewbillableAsset={createNewbillableAsset}  
        handleBillableAssetChange={handleBillableAssetChange} 
      />
      </>
    }
  </div>
  <ToastContainer></ToastContainer>
  </div>
};

const ExistingBillableAsset=({billableAsset, handleBillableAssetChange, setBillableAssets})=>{
  const [showDrawer, setShowDrawer] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [portfolioName, setPortfolioName] = useState(null);
  const [assetName, setAssetName] = useState(null);
  const [formData, setFormData] = useState({
    BillableAssetFlagId:0,
    PortfolioName: '',
    AssetName: '',
    NonAdvised: false,
    AdvisedNonBillable: false,
    AdvisedBillable: false,
  });

  const getNewData = async()=>{
    try{
      const list1 = await sbaAxios({url:getBillableAssetsGetExistingAPI});
      const list2 = await sbaAxios({url:getBillableAssetToFlagAPI});
      await handleBillableAssetChange(list1,list2);
    }
    catch(e){
      await handleBillableAssetChange([],[])     
    }
  };

  useEffect(()=>{
    getNewData();
  },[])

  const handleSearch = async()=>{
    try{
      const list = await sbaAxios({url:getBillableAssetsGetExistingAPI, params:{PortfolioSearchString: portfolioName, FundSearchString: assetName}});
      await setBillableAssets(list);
    }
    catch(e){
      await setBillableAssets([])
    }
  }
  const handleEditClick = (params) => {
    setFormData({
      BillableAssetFlagId: params.data.BillableAssetFlagId,
      PortfolioName: params.data.PortfolioName,
      AssetName: params.data.AssetName,
      NonAdvised: params.data.NonAdvised,
      AdvisedNonBillable: params.data.AdvisedNonBillable,
      AdvisedBillable: params.data.AdvisedBillable,
    });
    setShowDrawer(true);
  };

  const handleDeleteClick = (params) => {
    setSelectedAsset(params.data);
    setShowModel(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await sbaAxios({
        url: deleteBillableAsset,
        method: 'post',
        params: { billableAssetFlagId: selectedAsset.BillableAssetFlagId }
      });
      toast.success('Billable Asset deleted successfully');
    } catch (e) {
      console.log('Error:', e);
    }
    finally{
      await getNewData();
      setShowModel(false); // Close the modal after deletion
    }
  };

  // Handling checkbox changes
  const handleCheckboxChange = (field) => {
    setFormData((prev) => ({
      ...prev,
      NonAdvised: field === 'NonAdvised',
      AdvisedNonBillable: field === 'AdvisedNonBillable',
      AdvisedBillable: field === 'AdvisedBillable',
    }));
  };

  const handleUpdate = async() => {
    const updateData = {
      billableAssetFlagId: formData.BillableAssetFlagId,
      isNonAdvised: formData.NonAdvised,
      isAdvisedNonBillable: formData.AdvisedNonBillable,
      isAdvisedBillable: formData.AdvisedBillable
    }
    try{
      await sbaAxios({
        url:updateBillableAsset,
        method:'post',
        data:updateData
      })
      toast.success('Billable Asset updated successfully.')
    }
    catch(e){
      console.log('Error:',e);
      toast.error('Unable to update Billable Asset.')
    }
    finally{
      await handleSearch();
      setShowDrawer(false); // Close the drawer after update
    }
  };

  

  const handleCancel = () => {
    setShowDrawer(false); // Close the drawer without updating
  };

  // Custom cell renderer for the "Action" column
  const actionCellRenderer = (params) => {
    return (
      // <div>
      //   <button onClick={() => handleEditClick(params)} className="btn btn-sm btn-primary">Edit</button>
      //   <button onClick={() => handleDeleteClick(params)} className="btn btn-sm btn-danger" style={{ marginLeft: '5px' }}>Delete</button>
      // </div>
      <div className="actions-cell">
        <i className="fas fa-edit" style={{ color:"#47A547", margin: "0 8px", cursor: "pointer" }} onClick={() => handleEditClick(params)}></i>
        <i className="fa fa-trash" style={{ color: "red" , margin: "0 8px", cursor: "pointer" }} onClick={() => handleDeleteClick(params)}></i>
      </div>
    );
  };

  const colDef = [
    { headerName: "Portfolio Name", field: "PortfolioName" },
    { headerName: "Asset Name", field: "AssetName" },
    { headerName: "Non-Advised", field: "NonAdvised" , cellRenderer: 'agCheckboxCellRenderer' },
    { headerName: "Advised Non-Billable", field: "AdvisedNonBillable" ,cellRenderer: 'agCheckboxCellRenderer' },
    { headerName: "Advised Billable", field: "AdvisedBillable" ,cellRenderer: 'agCheckboxCellRenderer' },
    {
      headerName: "Action",
      field: "Action",
      cellRenderer: actionCellRenderer, // Use custom cell renderer for buttons
      sortable: false,
      filter: false
    }
  ];
  const defaultColDef = {
    sortable: true,
    filter: false,
    suppressMovable: true,
    flex: 1,
    resizable:true
  };
  return <>
    <SBADrawer
      open={showDrawer}
      setOpen={setShowDrawer}
      close={false}
      title={"Update Billable Asset"}
    >
      <div className="row ">
        <div className="col-md-6">
          <div>
            <label className="label">Portfolio Name</label>
            <input
              className="w-125 input-default form-control"
              type="text"
              Value={formData.PortfolioName}
              readOnly
            />
          </div>
        </div>
        <div className="col-md-6">
          <div>
            <label className="label">Fund Name</label>
            <input
              className="w-125 input-default form-control"
              type="text"
              Value={formData.AssetName}
              readOnly
            />
          </div>
        </div>
      </div>
      <div className="row m-0 my-3">
        <div className="col-md-4">
          <span className="fw-medium">Non Advised</span>
          <p>
            <input
              type="checkbox"
              checked={formData.NonAdvised}
              onChange={() => handleCheckboxChange('NonAdvised')}
            />
          </p>
        </div>
        <div className="col-md-4">
          <span className="fw-medium">Advised Non-Billable</span>
          <p>
            <input
              type="checkbox"
              checked={formData.AdvisedNonBillable}
              onChange={() => handleCheckboxChange('AdvisedNonBillable')}
            />
          </p>
        </div>
        <div className="col-md-4">
          <span className="fw-medium">Advised Billable</span>
          <p>
            <input
              type="checkbox"
              checked={formData.AdvisedBillable}
              onChange={() => handleCheckboxChange('AdvisedBillable')}
            />
          </p>
        </div>
      </div>
      <div className="m-1 d-flex justify-content-end mt-2">
        <button className="s-sm-btn mx-1" onClick={handleCancel}>Cancel</button>
        <button className="p-sm-btn mx-1" onClick={handleUpdate}>Update</button>
      </div>
    </SBADrawer>
   <div className="row">
      <div className='col-12 col-md-2'>
        <div>
          <label className="mb-1 label">Portfolio</label>
          <div>
            <input type="text"
              className="w-100 form-control"
              value={portfolioName}
              onChange={(e)=>{setPortfolioName(e.target.value)}}
            />
          </div>
        </div>
      </div>
      <div className='col-12 col-md-2'>
        <div>
          <label className="mb-1 label">Asset</label>
          <div>
            <input type="text"
              className="w-100 form-control"
              value={assetName}
              onChange={(e)=>{setAssetName(e.target.value)}} 
            />
          </div>
        </div>
      </div>
      <div className='col-12 col-md-2 row-items'>
        <button className="p-sm-btn" onClick={handleSearch}>Go</button>
      </div>
    </div>
    <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
      <AgGridReact rowData={billableAsset} columnDefs={colDef} defaultColDef={defaultColDef} />
    </div>
    {/* Modal for delete confirmation */}
    {selectedAsset && (
        <Modal show={showModel} onHide={() => setShowModel(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Billable Asset</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>The selected Billable Asset will be deleted permanently. Are you sure?</p>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => setShowModel(false)}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={handleDeleteConfirm}
            >
              Delete
            </button>
          </Modal.Footer>
        </Modal>
      )}
  </>
};
const CreateNewBillableAsset=({createNewbillableAsset, handleBillableAssetChange})=>{
  const [rowData, setRowData] = useState(createNewbillableAsset);
  const [modifiedRows, setModifiedRows] = useState([]);
  const [portfolioName, setPortfolioName] = useState(null);
  const [assetName, setAssetName] = useState(null);
  

  const getNewData = async()=>{
    try{
      const list1 = await sbaAxios({url:getBillableAssetsGetExistingAPI});
      const list2 = await sbaAxios({url:getBillableAssetToFlagAPI});
      await handleBillableAssetChange(list1,list2);
      await setRowData(list2);
    }
    catch(e){
      await handleBillableAssetChange([],[])    
      await setRowData([]) 
    }
  }
  const handleSearch = async()=>{

    try{
      const list = await sbaAxios({
        url: getBillableAssetToFlagAPI,
        params:{
          PortfolioSearchString:portfolioName,
          FundSearchString:assetName
        }
      });
      await setRowData(list);
    }
    catch(e){
      await setRowData([]);
    }
  }
  const colDef = [
    { headerName: "Portfolio Name", field: "PortfolioName" },
    { headerName: "Asset Name", field: "AssetName" },
    { headerName: "Non-Advised", field: "NonAdvised" , cellRenderer: 'agCheckboxCellRenderer' ,editable:true},
    { headerName: "Advised Non-Billable", field: "AdvisedNonBillable" ,cellRenderer: 'agCheckboxCellRenderer' ,editable:true},
    { headerName: "Advised Billable", field: "AdvisedBillable" ,cellRenderer: 'agCheckboxCellRenderer',editable:true },

  ];
  const defaultColDef = {
    sortable: true,
    filter: false,
    suppressMovable: true,
    flex: 1,
    resizable:true
  };
  // Update rowData and handle checkbox (radio button) behavior
  const onCellValueChanged = (params) => {
    const { field } = params.colDef;
    const { AssetPortfolioId, AssetId } = params.data; // Unique identifiers for the row
    const updatedData = rowData.map((row) => {
      if (row === params.data) {
        const updatedRow = {
          ...row,
          NonAdvised: field === "NonAdvised" ? true : false,
          AdvisedNonBillable: field === "AdvisedNonBillable" ? true : false,
          AdvisedBillable: field === "AdvisedBillable" ? true : false,
        };

        // Check if the row is already in the modifiedRows
        const existingIndex = modifiedRows.findIndex(
          r => r.AssetPortfolioId === updatedRow.AssetPortfolioId && r.AssetId === updatedRow.AssetId
        );

        if (existingIndex !== -1) {
          // Update the existing row
          const newModifiedRows = [...modifiedRows];
          newModifiedRows[existingIndex] = updatedRow;
          setModifiedRows(newModifiedRows);
        } else {
          // Add the new modified row
          setModifiedRows([...modifiedRows, updatedRow]);
        }

        return updatedRow;
      }
      return row;
    });
    setRowData(updatedData);
  };
  

  const transformToBillableAssetFlagDTO = (modifiedRows) => {
    return modifiedRows.map(row => ({
      BillableAssetFlagId: 0, // Set to 0 by default
      PortfolioId: row.AssetPortfolioId, // Map FndInsPortfolioId to PortfolioId
      AssetId: row.AssetId, // Map FndInsAssetId to AssetId
      IsNonAdvised: row.NonAdvised, // Map NonAdvised to IsNonAdvised
      IsAdvisedNonBillable: row.AdvisedNonBillable, // Map AdvisedNonBillable to IsAdvisedNonBillable
      IsAdvisedBillable: row.AdvisedBillable, // Map AdvisedBillable to IsAdvisedBillable
    }));
  };

  const handleSave = async()=>{
    const dataList = transformToBillableAssetFlagDTO(modifiedRows);
    try{
      await sbaAxios({url:insertNewBillableAsset,method:'post',data:dataList});
      toast.success('Billable Asset added successfully.')
      setModifiedRows([]);
    }
    catch(e){
      console.log('error:',e)
      toast.error('Unable to add Billable Asset.')
    }
    finally{
      await handleSearch();
    }
  }


  return <>
   <div className="row">
      <div className='col-12 col-md-2'>
        <div>
          <label className="mb-1 label">Portfolio</label>
          <div>
            <input type="text"
              className="w-100 form-control"
              value={portfolioName}
              onChange={(e)=>{setPortfolioName(e.target.value)}}
            />
          </div>
        </div>
      </div>
      <div className='col-12 col-md-2'>
        <div>
          <label className="mb-1 label">Asset</label>
          <div>
            <input type="text"
              className="w-100 form-control" 
              value = {assetName}
              onChange={(e)=>{setAssetName(e.target.value)}}/>
          </div>
        </div>
      </div>
      <div className='col-12 col-md-2 row-items'>
        <button className="p-sm-btn" onClick={handleSearch}>Go</button>
      </div>
      <div className='row-items justify-content-end'>
        <button className="p-sm-btn" onClick={handleSave} disabled={modifiedRows.length === 0}>Save</button>
      </div>
    </div>
    <div className="ag-theme-alpine m-1" style={{ height: '700px' }}>
      <AgGridReact     suppressScrollOnNewData={true}  rowData={rowData} columnDefs={colDef} defaultColDef={defaultColDef} onCellValueChanged={onCellValueChanged} />
    </div>
  </>
};